module.exports = __webpack_public_path__ + "static/media/logo-departamento-planeacion.07c7edf6.jpg";